import { atom } from "recoil";

export const pageResourcesAtom = atom<number>({
  key: "pageResourcesAtom",
  default: 1,
});
